import * as React from "react";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router";

const CssFooterTypography = styled(Typography)({
  color: "white",
  margin: "10px",
  fontSize: "12px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

const Footer = React.memo(({ fixed }) => {
  const footerStyle = {
    ...(fixed && { position: "fixed", bottom: 0 }),
  };
  const navigate = useNavigate();

  const _navigateToPage = (path, scrollToId = null) => {
    // ボタンがクリックされたときに遷移先のパスに遷移する
    navigate(path); // 指定されたパスに遷移する
    if (scrollToId) {
      setTimeout(() => {
        const targetElement = document.getElementById(scrollToId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }, 500); // 遷移後にスクロールするために少し待機する
    } else {
      window.scrollTo(0, 0); // ページの先頭にスクロールする
    }
  };

  function removeElementsByClass(className, length) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > length) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  return (
    <Fragment>
      <footer style={footerStyle}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            borderTop: "1px solid white",
            minWidth: "1200px",
            backgroundColor: "#303234",
          }}
        >
          <CssFooterTypography style={{ width: "80%" }}>
            <div>
              © 2024. 詳細は
              <span
                onClick={() => {
                  _navigateToPage("/Manual", "利用規約");
                  removeElementsByClass("cytoscape-navigator", 0);
                }}
                style={{
                  color: "rgb(0, 163, 224)",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                利用規約
              </span>
              をご覧ください。
            </div>
            <div>
              Deloitte（デロイト）とは、デロイト トウシュ トーマツ
              リミテッド（“DTTL”）、そのグローバルネットワーク組織を構成するメンバーファームおよびそれらの関係法人（総称して“デロイトネットワーク”）のひとつまたは複数を指します。DTTL（または“Deloitte
              Global”）ならびに各メンバーファームおよび関係法人はそれぞれ法的に独立した別個の組織体であり、第三者に関して相互に義務を課しまたは拘束させることはありません。DTTLおよびDTTLの各メンバーファームならびに関係法人は、自らの作為および不作為についてのみ責任を負い、互いに他のファームまたは関係法人の作為および不作為について責任を負うものではありません。DTTLはクライアントへのサービス提供を行いません。詳細は
              <a
                href="http://www.deloitte.com/jp/about"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "rgb(0, 163, 224)" }}
              >
                www.deloitte.com/jp/about
              </a>
              をご覧ください。
            </div>
          </CssFooterTypography>
        </Box>
      </footer>
    </Fragment>
  );
});

export default Footer;
